// Route Pages
const VerifyEmail = () => import('../../../components/common/pages/VerifyEmail.vue')
const VerifyWarning = () => import('../../../components/common/pages/VerifyWarning.vue')
const VerificationMethod = () => import('../../../components/common/pages/VerificationMethod.vue')
const VerificationCode = () => import('../../../components/common/pages/VerificationCode.vue')

export default () => {
  return [
    {
      path: '',
      name: 'TrustedDeviceWarning',
      component: VerifyWarning,
      props: true
    },
    {
      path: 'VerificationMethod',
      name: 'TrustedDeviceVerificationMethod',
      component: VerificationMethod,
      props: true
    },
    {
      path: 'VerificationCode',
      name: 'VerificationCode',
      component: VerificationCode,
      props: true
    },
    {
      path: 'Email',
      name: 'TrustedDeviceEmail',
      component: VerifyEmail,
      props: true
    }
  ]
}
